import { useEffect, useState } from 'react';
import axios from '@helpers/axios';
import { pollIntervals } from '@features/SidelineLive/sidelineLive.types';
import { strogging } from '@shd/jslib/infra';
import * as Sentry from '@sentry/browser';
import {
  BaseballLiveGame,
  BasicGameData,
  TeamGameLiveResponse,
  VolleyballGameData,
} from '@dto/api';
import { LiveScoringStatusHookResponse } from '@features/Schedule/schedule.d';

const useLiveGameStatus = (
  url: string | undefined,
  isEnded: boolean = false
): LiveScoringStatusHookResponse => {
  const [gameStatus, setGameStatus] = useState<
    TeamGameLiveResponse | undefined
  >();
  const [baseball, setBaseball] = useState<BaseballLiveGame | undefined>();
  const [volleyball, setVolleyball] = useState<
    VolleyballGameData | undefined
  >();
  const [otherSport, setOtherSport] = useState<BasicGameData | undefined>();
  const [polling, setPolling] = useState<pollIntervals>(
    pollIntervals.THIRTY_SECONDS
  );
  useEffect(() => {
    const fetchStatus = () =>
      axios
        .get(`${url}`)
        .then((response) => {
          const status = response.data;
          if (response.status === 200 && !status.isEnded) {
            setGameStatus(status);
            setBaseball(response.data.baseball);
            setVolleyball(response.data.volleyball);
            setOtherSport(response.data.otherSport);
            setPolling(() =>
              status.isEnded
                ? pollIntervals.THIRTY_SECONDS
                : pollIntervals.TEN_SECONDS
            );
          } else {
            setPolling(() => pollIntervals.THIRTY_SECONDS);
            setGameStatus(undefined);
            setBaseball(undefined);
            setVolleyball(undefined);
            setOtherSport(undefined);
          }
        })
        .catch((respError) => {
          strogging.log('SlOnPlatform - fetching live status error', respError);
          Sentry.captureException(respError);
        });
    const interval = setInterval(() => {
      !isEnded && fetchStatus();
    }, polling);

    return () => clearInterval(interval);
  }, [url, polling, isEnded]);

  return {
    gameStatus,
    baseball,
    volleyball,
    otherSport,
  };
};

export default useLiveGameStatus;
